import { cleanArray } from '../../common/utils';

export const getUserName = (
  {
    firstName,
    lastName,
    username,
  }: {
    username: string | null;
    firstName?: string | null;
    lastName?: string | null;
  },
  priority: 'displayName' | 'username' = 'displayName'
) =>
  priority === 'displayName'
    ? cleanArray([firstName, lastName]).join(' ') || username || ''
    : cleanArray([username, cleanArray([firstName, lastName]).join(' ')]).join(
        ' – '
      );
